export enum Routes {
  BASIC_APP = 'application-basic',
  APP_1003 = 'application-1003',
}
